import React from 'react'
import { Route } from 'react-router-dom'
import { AuthenticatedRoute, SignIn, StartOver } from 'modules/user'

import ChooseArgument from '../ChooseArgument'
import Builder from '../Builder'
import Question from '../Question'
import Review from '../Review'
import Strongest from '../Strongest'
import Layout from './Layout'
import enhance from './enhancers'

export function Main() {
  return (
    <Layout>
      <Route exact component={SignIn} path="/signin" />
      <AuthenticatedRoute>
        <StartOver />
        <Route exact component={ChooseArgument} path="/" />
        <Route component={Question} path="/question" />
        <Route component={Builder} path="/argument/:id/builder" />
        <Route component={Strongest} path="/argument/:id/strongest" />
        <Route component={Review} path="/argument/:id/review" />
      </AuthenticatedRoute>
    </Layout>
  )
}

export default enhance(Main)



// WEBPACK FOOTER //
// ./client/modules/debate/components/Main/index.js